import React, { Fragment, useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import Spinner from "../layout/Spinner";
import ChangeMeetingDate from "./ChangeMeetingDate";
import Pagination from "../layout/Pagination";

import {
  getVerifiedMeetingDetails,
  getMeetingTransactionData,
  batchAndMeetingDetails,
  unsetCheckAvailableMeetingDate,
  getLastMeetingDate,
} from "../../actions/shg";

const AllVerfiedMeetings = ({
  auth: { isAuthenticated, user, users },
  shg: { verifiedmeetingdetails,loadStatus },
  getVerifiedMeetingDetails,
  getMeetingTransactionData,
  batchAndMeetingDetails,
  unsetCheckAvailableMeetingDate,
  getLastMeetingDate,
}) => {
  let batchIdValue = JSON.parse(localStorage.getItem("batchIdValue"));
  useEffect(() => {
    getVerifiedMeetingDetails(batchIdValue);
    // getLastMeetingDate();
  }, [getVerifiedMeetingDetails]);


  // To change meeting date option

  const [userData1, setUserData1] = useState(null);
  const [showChangeModal, setShowChangeModal] = useState(false);
  const handleChangeModalClose = () => setShowChangeModal(false);

  const onChangeModalChange = (e) => {
    if (e) {
      handleChangeModalClose();
    }
  };
  const [previousData, setPreviousDate] = useState("");
  const [aheadDate, setAheadDate] = useState("");

  const onChangeMeetingDate = (verifiedmeeting, idx) => {
    if (idx != 0 && idx !== verifiedmeetingdetails.length - 1) {
      setPreviousDate(verifiedmeetingdetails[idx - 1]);
      setAheadDate(verifiedmeetingdetails[idx + 1]);

      unsetCheckAvailableMeetingDate();
      setShowChangeModal(true);
      setUserData1(verifiedmeeting);
    } else if (idx === 0) {
      setPreviousDate(verifiedmeetingdetails[idx]);
      setAheadDate(
        verifiedmeetingdetails[idx + 1] || new Date().toISOString().slice(0, 10)
      );
      unsetCheckAvailableMeetingDate();
      setShowChangeModal(true);
      setUserData1(verifiedmeeting);
    } else {
      setPreviousDate(verifiedmeetingdetails[idx - 1]);
      setAheadDate(verifiedmeetingdetails[idx]);
      unsetCheckAvailableMeetingDate();
      setShowChangeModal(true);
      setUserData1(verifiedmeeting);
    }
  };

   if (JSON.parse(localStorage.getItem("all-verified-report-page-index")) === null) {
    localStorage.setItem("all-verified-report-page-index", 1);
  }
  //pagination code
  const [currentData, setCurrentData] = useState(JSON.parse(localStorage.getItem("all-verified-report-page-index")));
  const [dataPerPage] = useState(24);
  //Get Current Data
  const indexOfLastData = currentData * dataPerPage;
  const indexOfFirstData = indexOfLastData - dataPerPage;
  const currentDatas =
  verifiedmeetingdetails &&
  verifiedmeetingdetails.slice(indexOfFirstData, indexOfLastData);
  //change page
  const paginate = (nmbr) => {
    setCurrentData(nmbr);
  };
  //pagination code ends

  const handleVerifyEditBatch = (verifiedmeetingdetails) => {
    localStorage.removeItem("batchTransactionData");
    localStorage.setItem("all-verified-report-page-index",currentData)
    const batchIdData = {
      batchId: verifiedmeetingdetails.mdBatchId,
      batchTransactionType: verifiedmeetingdetails.batchTransactionType,
      mdDate: verifiedmeetingdetails.mdDate,
      mdBatchId: verifiedmeetingdetails.mdBatchId,
      batchIdVal: batchIdValue.batchIdVal,
      batchName: batchIdValue.batchName,
      callFrom: "Report",
    };
    let meetingBatchInfo = batchIdData;
    getMeetingTransactionData(meetingBatchInfo);
    batchAndMeetingDetails(batchIdData);
  };
  return !isAuthenticated || !user || !users ? (
    <Spinner />
  ) : (
    loadStatus ? <Spinner /> :
    <Fragment>
      <div className="container container_align ">
        <div className="col-lg-11 col-md-11 col-sm-12 col-12">
          <h2 className="heading_color">
            {" "}
            Meetings of&nbsp;{batchIdValue.batchName}
          </h2>
          <hr />
        </div>
        <section className="sub_reg">
          <div className="row col-lg-12 col-md-11 col-sm-12 col-12 no_padding">
            <div className="col-lg-11 col-md-11 col-sm-11 col-11 py-3">
              <Link to="/batchwise-report">
                <img
                  className="img_icon_size log float-right"
                  src={require("../../static/images/back.png")}
                   onClick={()=>localStorage.removeItem("all-verified-report-page-index")}
                  alt="Back"
                  title="Back"
                />
              </Link>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-11 col-md-11 col-sm-11 col-11 text-center ">
              <section className="body">
                <div className=" body-inner no-padding table-responsive ">
                  <table
                    className="table table-bordered table-striped table-hover"
                    id="datatable2"
                  >
                    <thead>
                      <tr>
                        <th>Meeting Date</th>
                        <th>Entered By</th>
                        <th>Change Date</th>
                      </tr>
                    </thead>
                    <tbody>
                      {currentDatas &&
                        currentDatas.map(
                          (verifiedmeetingdetails, idx) => {
                            var ED = verifiedmeetingdetails.mdDate.split(/\D/g);
                            var mdDate = [ED[2], ED[1], ED[0]].join("-");
                            return (
                              <tr key={idx}>
                                <td>
                                  {" "}
                                  <Link
                                    to={{
                                      pathname:
                                        verifiedmeetingdetails &&
                                        verifiedmeetingdetails.batchTransactionType ===
                                          "Memberwise"
                                          ? "/verification-batch-membermeeting"
                                          : "/verification-batchmeeting",
                                    }}
                                    className="btnLink"
                                    onClick={() =>
                                      handleVerifyEditBatch(
                                        verifiedmeetingdetails
                                      )
                                    }
                                  >
                                    {mdDate}
                                  </Link>
                                </td>
                                <td>
                                  {verifiedmeetingdetails.mdEnteredByName}
                                </td>

                                <td>
                                  {user && user.userGroupName == "Admin" ? (
                                    <img
                                      className="img_icon_size log"
                                      onClick={() =>
                                        onChangeMeetingDate(
                                          verifiedmeetingdetails,
                                          idx
                                        )
                                      }
                                      src={require("../../static/images/changecode.png")}
                                      alt="Change Meeting Date"
                                      title="Change Meeting Date"
                                    />
                                  ) : (
                                    "Only Admin Can Change Date"
                                  )}
                                </td>
                              </tr>
                            );
                          }
                        )}
                    </tbody>
                  </table>
                </div>
                <div className="row col-lg-12 col-md-6 col-sm-11 col-11 align_right ">
                <div className="col-lg-6 col-md-6 col-sm-12 col-12 no_padding">
                    {verifiedmeetingdetails && verifiedmeetingdetails.length !== 0 ? (
                      <Pagination
                        dataPerPage={dataPerPage}
                        totalData={verifiedmeetingdetails.length}
                        paginate={paginate}
                        currentPage={currentData}
                      />
                    ) : (
                      <Fragment />
                    )}
                   
                  </div>
                  <div className="col-lg-6 col-md-6 col-sm-12 col-12 no_padding mt-1">
                  <label>
                    <b>Meeting Count: {verifiedmeetingdetails.length}</b>
                  </label>
                  </div>
                </div>
              </section>
            </div>
          </div>
        </section>

        <Modal
          show={showChangeModal}
          backdrop="static"
          keyboard={false}
          size="md"
          aria-labelledby="contained-modal-title-vcenter"
          centered
        >
          <Modal.Header>
            <div className="col-lg-10 col-md-10 col-sm-10 col-10">
              <h3 className="modal-title text-center">Change Meeting Date </h3>
            </div>
            <div className="col-lg-2 col-md-2 col-sm-2 col-2">
              <button onClick={handleChangeModalClose} className="close">
                <img
                  src={require("../../static/images/close.png")}
                  alt="X"
                  style={{ height: "20px", width: "20px" }}
                />
              </button>
            </div>
          </Modal.Header>
          <Modal.Body>
            <ChangeMeetingDate
              batchesdata={userData1}
              onChangeModalChange={onChangeModalChange}
              previousDate={previousData}
              aheadDate={aheadDate}
            />
          </Modal.Body>
        </Modal>
      </div>
    </Fragment>
  );
};

AllVerfiedMeetings.propTypes = {
  auth: PropTypes.object.isRequired,
  shg: PropTypes.object.isRequired,
  getVerifiedMeetingDetails: PropTypes.func.isRequired,
  getMeetingTransactionData: PropTypes.func.isRequired,
  batchAndMeetingDetails: PropTypes.func.isRequired,
  unsetCheckAvailableMeetingDate: PropTypes.func.isRequired,
};
const mapStateToProps = (state) => ({
  auth: state.auth,
  shg: state.shg,
});

export default connect(mapStateToProps, {
  getVerifiedMeetingDetails,
  getMeetingTransactionData,
  batchAndMeetingDetails,
  unsetCheckAvailableMeetingDate,
  getLastMeetingDate,
})(AllVerfiedMeetings);
